<!--Wird von Rossmann im Aktivierungsprozess Summary eingebunden-->
<template>
  <div id="top-up-activation-summary">
    <slot name="txtBeforeTopUpActivationSummary"></slot>
    <Monthly :topUpInfo="topUp" v-if="topUp.type === 'monthly'">
      <template #txtMonthlyHeader><slot name="txtMonthlyHeaderWrapper"></slot></template>
      <template #txtTopUpAmount><slot name="txtTopUpAmountWrapper"></slot></template>
      <template #txtMonthlyDesc><slot name="txtMonthlyDescWrapper"></slot></template>
    </Monthly>
    <ByLimit :topUpInfo="topUp" v-if="topUp.type === 'byLimit'">
      <template #txtByLimitHeader><slot name="txtByLimitHeaderWrapper"></slot></template>
      <template #txtTopUpTriggerByLimit><slot name="txtTopUpTriggerByLimitWrapper"></slot></template>
      <template #txtTopUpAmountByLimit><slot name="txtTopUpAmountByLimitWrapper"></slot></template>
      <template #txtByLimitDesc><slot name="txtByLimitDescWrapper"></slot></template>
    </ByLimit>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Monthly from '../Summary/Monthly.vue'
import ByLimit from '../Summary/ByLimit.vue'

export default {
  name: 'TopUpSummaryWrapper',
  computed: {
    ...mapGetters('activation/topUp', [
      'topUp'
    ])
  },
  components: {
    Monthly,
    ByLimit
  }
}
</script>
